import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function TrackingPixels ({ src1, src2, src3, src4 }) {
  const injectPixel = (pixelId) => {
    const pixelScript = document.createElement('script');
    pixelScript.setAttribute('type', 'text/javascript');
    pixelScript.innerHTML = `var axel = Math.random() + "";
        var a = axel * 10000000000000
        document.body.insertAdjacentHTML('beforeend', '<img id="pixel1-${pixelId}" src="${src1}' + a + '?" width="1" height="1" alt=""/>');`;

    const pixelNoscript = document.createElement('noscript');
    pixelNoscript.innerHTML = '<img src="' + src2 + '" width="1" height="1" alt=""/>';

    document.body.prepend(pixelScript, pixelNoscript);
    document.body.insertAdjacentHTML('beforeend', '<img id="pixel2-' + pixelId + '" height="1" width="1" style="border-style:none;" alt="" src="' + src3 + '"/>');
    document.body.insertAdjacentHTML('beforeend', '<img id="pixel3-' + pixelId + '" src="' + src4 + '" width="1" height="1" />');

    return [pixelScript, pixelNoscript];
  };

  const removePixel = (pixelElements, pixelId) => {
    pixelElements.forEach(element => {
      element.remove();
    });

    document.getElementById(`pixel1-${pixelId}`).remove();
    document.getElementById(`pixel2-${pixelId}`).remove();
    document.getElementById(`pixel3-${pixelId}`).remove();
  };

  useEffect(() => {
    const pixelId = Date.now();
    const pixelElements = injectPixel(pixelId);

    return () => {
      removePixel(pixelElements, pixelId);
    };
  }, []);

  return <></>;
}

TrackingPixels.propTypes = {
  src1: PropTypes.any,
  src2: PropTypes.any,
  src3: PropTypes.any,
  src4: PropTypes.any
};

export default TrackingPixels;
